module.exports = __webpack_public_path__ + "user/static/media/logo-white.fa22ba93.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Footer/Logo/logo-white.png
// module id = 403
// module chunks = 38